import { useEffect, useState } from "react";

import firebase from "firebase/app";
import"firebase/storage";

export const useStorage = (fileName) => {
  const [fileUrls, setFileUrls] = useState("");

  const getFileURL = async (payload) => {
    const url = await firebase
      .storage()
      .ref()
      .child(payload.name)
      .getDownloadURL();
    setFileUrls(url);
  };

  useEffect(() => {
    const parts = fileName.split("/");
    if (parts[parts.length - 1] !== "" && fileName !== "" && !fileUrls) {
      getFileURL({ name: fileName });
    }
  }, [fileName, fileUrls]);

  return fileUrls ?? "";
};

//   interface GetFileUrlRequest {
//     name: string; //->file/email/file_name
//   }
